import { loginRequests, loginSteps } from "../../constants";

export const signInActions = {
  FIELD_CHANGED: "fieldChanged",
  STEP_CHANGED: "stepChanged",
  RESTARTED: "restarted",
  REQUEST_STARTED: "requestStarted",
  REQUEST_FAILED: "requestFailed",
  CHALLENGE_UPDATED: "challengeUpdated",
};

// Fields of the second factor steps; the first step's fields belong to the page that renders it
const emptyFields = { phoneNumber: "", code: "" };

export const initialSignInState = {
  step: loginSteps.CREDENTIALS,
  // 1 slides the next step in from the right, -1 from the left
  direction: 1,
  fields: emptyFields,
  // loginToken, requiresPhoneNumber, maskedPhoneNumber, resendAt, resendsRemaining
  challenge: null,
  // One of loginRequests while a request is in flight
  pendingRequest: null,
  error: "",
  notice: "",
};

function goTo(state, step, direction = 1) {
  return { ...state, step, direction, error: "", notice: "" };
}

export default function signInReducer(state, action) {
  switch (action.type) {
    case signInActions.FIELD_CHANGED:
      return {
        ...state,
        fields: { ...state.fields, [action.name]: action.value },
        // Typing a new code clears the error shown on the code boxes
        error: action.name === "code" ? "" : state.error,
      };

    case signInActions.STEP_CHANGED:
      return goTo(state, action.step, action.direction);

    // Back to the first step, e.g. "Back to sign in" or the server ending the sign-in (with its error)
    case signInActions.RESTARTED:
      return {
        ...goTo(state, loginSteps.CREDENTIALS, -1),
        fields: emptyFields,
        challenge: null,
        pendingRequest: null,
        error: action.error || "",
      };

    case signInActions.REQUEST_STARTED:
      return { ...state, pendingRequest: action.request, error: "", notice: "" };

    case signInActions.REQUEST_FAILED: {
      const { error, resendAt } = action;

      // A rejected code is cleared so the next one can be typed straight in
      const isRejectedCode =
        state.step === loginSteps.OTP_REQUIRED && state.pendingRequest === loginRequests.SUBMIT;

      return {
        ...state,
        pendingRequest: null,
        error,
        fields: isRejectedCode ? { ...state.fields, code: "" } : state.fields,
        challenge: resendAt ? { ...state.challenge, resendAt } : state.challenge,
      };
    }

    // A sign-in challenge started or a code was sent, optionally moving to the next step
    case signInActions.CHALLENGE_UPDATED: {
      const next = action.step ? goTo(state, action.step) : state;

      return {
        ...next,
        pendingRequest: null,
        notice: action.notice || "",
        fields: { ...next.fields, code: "" },
        challenge: { ...next.challenge, ...action.challenge },
      };
    }

    default:
      return state;
  }
}
